// extracted by mini-css-extract-plugin
export default {"mainContainer":"mainContainer___bOE5v","filtersContainer":"filtersContainer___IVY3i"};